import { render } from "./ProductsImportModal.vue?vue&type=template&id=3d0810bd"
import script from "./ProductsImportModal.vue?vue&type=script&lang=js"
export * from "./ProductsImportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__